import { ref } from 'vue';

export const useView = () => {
  const views = {
    DEFAULT: 'default',
    CHECKOUT: 'checkout',
  };

  const currentView = ref(views.DEFAULT);

  const changeView = (view) => {
    currentView.value = view;
  };

  const isCurrentView = (view) => currentView.value === view;

  return {
    views,
    changeView,
    isCurrentView,
  };
};
